export default "__VITE_ASSET__CWe5byJw__"